/* cwc-cart-icon */
:host {
  .wrap {
    display: flex;
    position: relative;
    align-items: center;
    height: auto;
    max-height: 100%;
    aspect-ratio: 1 /1;
  }

  .bubble {
    display: flex;
    position: absolute;
    top: -4px;
    right: -4px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    transform: translate(5px, -5px);
    border: 1px solid var(--navigation-elements-main-nav-background-color, #fff);
    border-radius: 9px;
    background-color: var(--cwc-cart-icon-badge-bg-color, var(--navigation-elements-main-nav-icon-color, #1586c4));

    @media screen and (min-width: 1024px) {
      width: 25px;
      height: 25px;
      border: 2px solid var(--navigation-elements-main-nav-background-color, #fff);
      border-radius: 12.5px;
    }

    @supports not (aspect-ratio: 1 / 1) {
      display: none;
    }
  }

  .extended-width {
    width: 24px;
    @media screen and (min-width: 1024px) {
      width: 30px;
    }
  }

  .count {
    fill: var(--cwc-cart-icon-badge-color, var(--navigation-elements-main-nav-background-color, #fff));
    font-weight: 600;
  }

  .hide {
    display: none;
  }

  .count-svg {
    width: 100%;
    height: 100%;
  }
}
